module.exports = __webpack_public_path__ + "static/white-wave-839088f9ad4932db663455b9576469ec.png";